import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRouteSnapshot, Event, ActivationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { buffer, pluck } from 'rxjs/operators';
import { IBreadcrumb } from '../../interfaces/breadcrumb';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {
  breadcrumbsSubject: BehaviorSubject<IBreadcrumb[]> = new BehaviorSubject([]);
  breadcrumbs: IBreadcrumb[];
  isNavigationEnd = (ev: Event) => ev instanceof NavigationEnd;
  isActivationEnd = (ev: Event) => ev instanceof ActivationEnd;

  constructor(public router: Router) {
    const navigationEnd$ = this.router.events.pipe(filter(this.isNavigationEnd));

    this.router.events
      .pipe(filter(this.isActivationEnd), pluck('snapshot'), buffer(navigationEnd$))
      .subscribe((activatedRoutes: ActivatedRouteSnapshot[]) => {
        this.buildBreadcrumbsOnChangeRoute(activatedRoutes);
      });

    this.breadcrumbs = [];
    this.breadcrumbsSubject.next(this.breadcrumbs);
  }

  buildBreadcrumbsOnChangeRoute(activatedRoutes: ActivatedRouteSnapshot[]) {
    if (activatedRoutes.length && activatedRoutes[0].data && activatedRoutes[0].data.breadcrumbs) {
      const queryParams = activatedRoutes[0].queryParams;

      this.breadcrumbs = [...activatedRoutes[0].data.breadcrumbs];
      this.setParams(queryParams);
      this.breadcrumbsSubject.next(this.breadcrumbs);
    } else {
      this.clearBreadcrumbs();
    }
  }
  clearBreadcrumbs() {
    this.breadcrumbs = [];
    this.breadcrumbsSubject.next([]);
  }
  setBreadcrumbsParamsFromLocation(paramsObj) {
    this.setParams(paramsObj);
    this.breadcrumbsSubject.next(this.breadcrumbs);
  }
  setParams(params) {
    this.breadcrumbs.map((newBreadcrumb) => {
      if (newBreadcrumb.hasOwnProperty('queryParams')) {
        newBreadcrumb.queryParams = params;
      }
    });
  }
}
